import { IDropdownStyles, IPivotStyles, IStyle } from '@fluentui/react';

export interface IEScorerPageStyles {
  root?: IStyle;
  filterContainer?: IStyle;
  dropdowns?: IStyle;
}

export const escorerPageStylesDefault = (): Partial<IEScorerPageStyles> => ({
  root: {
    width: '100%',
  },
  filterContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  dropdowns: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: 300,
  },
};

export const pivotStyles: Partial<IPivotStyles> = {
  root: {
    marginTop: '1rem',
  },
};
